var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('img',{attrs:{"src":require("@/assets/icons/icon_arrow.svg"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }